
import React from 'react';
import { Font } from '@react-pdf/renderer';


Font.register({ family: 'MuliRegular', src: `${process.env.REACT_APP_SUBFOLDER}/assets/fonts/Muli/Muli-Regular.ttf` });
Font.register({ family: 'MuliLight', src: `${process.env.REACT_APP_SUBFOLDER}/assets/fonts/Muli/Muli-Light.ttf` });
Font.register({ family: 'MuliExtraBold', src: `${process.env.REACT_APP_SUBFOLDER}/assets/fonts/Muli/Muli-ExtraBold.ttf` });
Font.register({ family: 'MuliBold', src: `${process.env.REACT_APP_SUBFOLDER}/assets/fonts/Muli/Muli-Bold.ttf` });
Font.register({ family: 'MuliBlack', src: `${process.env.REACT_APP_SUBFOLDER}/assets/fonts/Muli/Muli-Black.ttf` });

export default ({ children = null }) => <>{children}</>;
